/* Proteccion de envio opcional (precio fijo $4.900, en pesos chilenos) - Dear Noel */
(function () {
  if (window.__dnProt) return; window.__dnProt = true;
  // Los importes de Shopify van en centavos (x100), tambien en CLP: 500 pesos = 50000.
  var HANDLE = 'proteccion-de-envio', PCT = 0.10, STEP = 50000, MIN = 50000, MAX = 700000;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var VARIANTS = null, busy = false, timer = null, tries = 0;

  var css = '.dn-prot{border:1px solid rgba(var(--color-foreground),.15);border-radius:12px;padding:12px 14px;margin:0 0 14px;text-align:left}' +
    '.dn-prot__row{display:flex;align-items:center;gap:12px;cursor:pointer;margin:0}' +
    '.dn-prot__icon{flex:0 0 auto;display:flex}' +
    '.dn-prot__text{flex:1 1 auto;display:flex;flex-direction:column;gap:2px;font-size:1.4rem;line-height:1.35}' +
    '.dn-prot__text small{font-size:1.2rem;opacity:.75}' +
    '.dn-prot__price{font-weight:400;opacity:.8;white-space:nowrap}' +
    '.dn-prot__switch{position:relative;flex:0 0 44px;width:44px;height:24px}' +
    '.dn-prot__switch input{position:absolute;inset:0;opacity:0;margin:0;cursor:pointer;z-index:1}' +
    '.dn-prot__slider{position:absolute;inset:0;border-radius:24px;background:rgba(var(--color-foreground),.2);transition:background .2s}' +
    '.dn-prot__slider:before{content:"";position:absolute;width:18px;height:18px;left:3px;top:3px;border-radius:50%;background:#fff;box-shadow:0 1px 3px rgba(0,0,0,.25);transition:transform .2s}' +
    '.dn-prot__switch input:checked+.dn-prot__slider{background:rgb(var(--color-button))}' +
    '.dn-prot__switch input:checked+.dn-prot__slider:before{transform:translateX(20px)}' +
    '.dn-prot__switch input:disabled+.dn-prot__slider{opacity:.5}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  function getCart() { return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function post(url, body) {
    return fetch(root + url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
  }
  async function loadVariants() {
    if (VARIANTS) return VARIANTS;
    try {
      var p = await (await fetch(root + 'products/' + HANDLE + '.js')).json();
      VARIANTS = p.variants.filter(function (v) { return v.available; }).map(function (v) { return { id: v.id, price: v.price }; });
    } catch (e) { VARIANTS = []; }
    return VARIANTS;
  }
  // Precio fijo: $4.900 si hay al menos un producto en el carrito.
  function amountFor(cart) {
    var base = 0;
    cart.items.forEach(function (i) { if (i.handle !== HANDLE) base += i.final_line_price; });
    return base > 0 ? 490000 : 0;
  }
  function variantFor(cents, vs) {
    var best = null;
    vs.forEach(function (v) { if (!best || Math.abs(v.price - cents) < Math.abs(best.price - cents)) best = v; });
    return best;
  }
  // Pesos chilenos: punto para los miles y sin decimales ($4.000)
  function money(c) { return '$' + String(Math.round(c / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }

  function targets() {
    return Array.prototype.filter.call(
      document.querySelectorAll('#CartDrawer .cart-drawer__footer .totals, .cart__footer .totals'),
      function (t) { var p = t.previousElementSibling; return !(p && p.classList.contains('dn-prot')); }
    );
  }
  async function render() {
    var ts = targets(); if (!ts.length) return;
    var vs = await loadVariants(); if (!vs.length) return;
    var cart = await getCart();
    var amt = amountFor(cart);
    var lines = cart.items.filter(function (i) { return i.handle === HANDLE; });
    var on = lines.length > 0;
    if (on) {
      var want = amt ? variantFor(amt, vs) : null;
      if (!want || lines.length > 1 || lines[0].variant_id !== want.id || lines[0].quantity !== 1) { if (tries++ < 3) setTimeout(resync, 0); return; }
      tries = 0;
    }
    if (!amt) return;
    var shown = variantFor(amt, vs);
    targets().forEach(function (t) {
      var d = document.createElement('div');
      d.className = 'dn-prot';
      d.innerHTML = '<label class="dn-prot__row">' +
        '<span class="dn-prot__icon" aria-hidden="true"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="m9 12 2 2 4-4"/></svg></span>' +
        '<span class="dn-prot__text"><strong>Protección de envío <span class="dn-prot__price">+' + money(shown ? shown.price : amt) + '</span></strong>' +
        '<small>Si tu pedido se pierde, se daña o lo roban en el camino, te enviamos uno nuevo sin costo.</small></span>' +
        '<span class="dn-prot__switch"><input type="checkbox" data-dn-prot-toggle aria-label="Agregar protección de envío"' + (on ? ' checked' : '') + '><span class="dn-prot__slider"></span></span>' +
        '</label>';
      t.parentNode.insertBefore(d, t);
    });
  }
  function scheduleRender() { clearTimeout(timer); timer = setTimeout(function () { render().catch(function () {}); }, 150); }

  // Deja 0 o 1 linea de proteccion con el monto correcto. Devuelve true si cambio algo.
  async function sync(on) {
    var vs = await loadVariants(); if (!vs.length) return false;
    var cart = await getCart();
    var lines = cart.items.filter(function (i) { return i.handle === HANDLE; });
    var amt = on ? amountFor(cart) : 0;
    var v = amt ? variantFor(amt, vs) : null;
    if (v && lines.length === 1 && lines[0].variant_id === v.id && lines[0].quantity === 1) return false;
    if (!v && !lines.length) return false;
    if (lines.length) {
      var updates = {}; lines.forEach(function (l) { updates[l.key] = 0; });
      await post('cart/update.js', { updates: updates });
    }
    if (v) await post('cart/add.js', { items: [{ id: v.id, quantity: 1 }] });
    return true;
  }
  async function refresh() {
    if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
    var s = await (await fetch(root + '?sections=cart-drawer,cart-icon-bubble')).json();
    var parse = function (h) { return new DOMParser().parseFromString(h, 'text/html'); };
    if (s['cart-drawer']) {
      var doc = parse(s['cart-drawer']);
      var fresh = doc.querySelector('#CartDrawer'), cur = document.querySelector('#CartDrawer');
      if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      var fd = doc.querySelector('cart-drawer'), dr = document.querySelector('cart-drawer');
      if (fd && dr) dr.classList.toggle('is-empty', fd.classList.contains('is-empty'));
    }
    if (s['cart-icon-bubble']) {
      var b = document.getElementById('cart-icon-bubble');
      var n = parse(s['cart-icon-bubble']).querySelector('.shopify-section');
      if (b && n) b.innerHTML = n.innerHTML;
    }
    scheduleRender();
  }

  document.addEventListener('change', async function (e) {
    var cb = e.target.closest && e.target.closest('[data-dn-prot-toggle]');
    if (!cb || busy) return;
    busy = true; cb.disabled = true;
    try { await sync(cb.checked); await refresh(); }
    catch (err) { console.error('Proteccion de envio:', err); cb.checked = !cb.checked; }
    busy = false; cb.disabled = false;
  });

  async function resync() {
    if (busy) return; busy = true;
    try {
      var cart = await getCart();
      if (cart.items.some(function (i) { return i.handle === HANDLE; }) && await sync(true)) await refresh();
    } catch (e) { console.error('Proteccion de envio:', e); }
    busy = false;
  }

  function start() {
    new MutationObserver(function () { if (targets().length) scheduleRender(); })
      .observe(document.body, { childList: true, subtree: true });
    scheduleRender();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(resync, 300); });
    }
    resync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
